import { apiClient } from "../config";

async function deleteReports(id: any) {
  const res = await apiClient.delete(`/admin/reports/${id}`);
  return res.data;
}

export default deleteReports;
